module.exports = __webpack_public_path__ + "img/banner05.491ace5e.png";